module.exports = __webpack_public_path__ + "img/logout-icon.f6e96514.png";